module.exports = __webpack_public_path__ + "img/rightside_1000.e0a3be83.png";